import { render, staticRenderFns } from "./guideline.vue?vue&type=template&id=5974a2db&scoped=true&"
import script from "./guideline.vue?vue&type=script&lang=js&"
export * from "./guideline.vue?vue&type=script&lang=js&"
import style0 from "./guideline.vue?vue&type=style&index=0&id=5974a2db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974a2db",
  null
  
)

export default component.exports